module.exports = __webpack_public_path__ + "static/media/ldc.ab5d6830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/ldc.jpg
// module id = 206
// module chunks = 0